import { processSteps, type Offer } from "../config/offers";
import type { MoneyPageContent } from "../content/moneyPages";
import {
  accentRailMarkup,
  checkList,
  ctaBand,
  faqSection,
  paragraphs,
  siteFooter,
  topNav
} from "./layout";

export function renderMoneyPage(
  offer: Offer,
  content: MoneyPageContent,
  assetBase: string
): string {
  const crossHref =
    offer.id === "local-trust-pack" ? "/website-audit-service" : "/google-review-management";
  const crossLabel =
    offer.id === "local-trust-pack" ? "See the website audit" : "See review management";

  return `
    <main data-screen-label="${content.eyebrow}">
      ${topNav(assetBase)}

      <section class="section page-hero" data-screen-label="Hero">
        <div class="page-hero-inner">
          ${accentRailMarkup()}
          <p class="eyebrow">${content.eyebrow}</p>
          <h1>${content.h1}</h1>
          <p class="hero-subhead">${content.heroSub}</p>
          <div class="actions">
            <a class="button button-primary" href="${offer.paymentUrl}">${offer.cta}</a>
            <a class="button button-outline" href="#included">See what's included</a>
          </div>
          <p class="proof-line">$149/month · No contracts · Cancel anytime</p>
        </div>
      </section>

      <section id="included" class="section" data-screen-label="Included">
        <div class="section-heading">
          ${accentRailMarkup()}
          <h2>${content.includedHeading}</h2>
        </div>
        <ul class="benefit-list benefit-list-wide">${checkList(offer.ships)}</ul>
      </section>

      <section id="pricing" class="section section-soft" data-screen-label="Pricing">
        <div class="pricing-band">
          <div class="pricing-price"><span>${offer.price}</span></div>
          <div class="pricing-copy">
            <h2>${content.pricingHeading}</h2>
            <p>${content.pricingBody}</p>
            <a class="button button-primary" href="${offer.paymentUrl}">${offer.cta}</a>
          </div>
        </div>
      </section>

      <section class="section" data-screen-label="Who">
        <div class="section-heading">
          ${accentRailMarkup()}
          <h2>${content.whoHeading}</h2>
          ${paragraphs(offer.who)}
        </div>
        <div class="who-links">${content.whoLinks
      .map((link) => `<a class="who-link" href="${link.href}">${link.label} →</a>`)
      .join("")}</div>
      </section>

      <section class="section section-soft" data-screen-label="Process">
        <div class="section-heading">
          <h2>How it works</h2>
        </div>
        <div class="process-grid">${processSteps
      .map(
        (step) =>
          `<article class="spec-cell"><span>${step.number}</span><h3>${step.title}</h3><p>${step.body}</p></article>`
      )
      .join("")}</div>
      </section>

      ${faqSection(content.faqHeading, content.faqs)}

      ${ctaBand({
        headline: content.finalHeadline,
        body: content.finalBody,
        primaryHref: offer.paymentUrl,
        primaryLabel: offer.cta,
        secondaryHref: crossHref,
        secondaryLabel: crossLabel,
        microcopy: "$149/month · Cancel anytime · No long-term contract"
      })}
    </main>
    ${siteFooter()}
  `;
}
